<template>
  <DialogTemplateToolkit
    class-name="select-existing-field"
    :data-qa="'select-existing-field-dialog'"
    :dialog="opened"
    first_btn="Common.Add"
    :title="$t('AdditionalFields.SelectExistingField')"
    width="856"
    without_second_btn
    @apply="addFields"
    @close="$emit('close')">
    <template #backBtn>
      <sButton
        v-if="back_step"
        class="bold h7-text px-2"
        data-qa="back-btn"
        icon="long-arrow"
        icon-class="s-svg-icon-rotate-90"
        small
        type="text"
        @click="$emit( 'back')">
        {{ $t('Common.Back') }}
      </sButton>
    </template>
    <template #card-text>
      <div
        class="py-2"
        style="overflow: auto; max-height: calc(100vh - 405px);">
        <div
          v-if="loading"
          class="my-5 mx-auto text-center">
          <sIcon
            color="var(--secondary__green_not_active)"
            size="30"
            spin
            type="loading"/>
        </div>
        <v-treeview
          v-else-if="groups && groups.length"
          id="fieldTree"
          ref="catalog"
          v-model="selected"
          expand-icon="down-arrow"
          hoverable
          item-disabled="locked"
          :items="groups"
          open-all
          open-on-click
          return-object
          selectable
          selected-color="var(--black-color)"
          transition>
          <template #label="{item}">
            <div
              v-if="item.type"
              class="flex align-center"
              :data-qa="`additional-existing-field__${item.id}`">
              <sIcon
                class="additional-field-type__icon my-auto mr-2"
                :type="item.type.icon"/>
              <div class="h7-text-medium">
                {{ item.type.name }}
              </div>
              <div
                v-if="item.type.caption"
                class="h9-text secondary__green_not_active--text mx-4">
                ( {{ item.type.caption }} )
              </div>

              <div
                v-if="item.children"
                class="h9-text secondary__green_not_active--text ml-auto">
                {{ item.children.length }}
              </div>
            </div>
            <div
              v-else
              class="flex flex-between">
              <span
                class="field-title"
                :class="{'required-label': item.required}"
                style="white-space: break-spaces;"> {{ item.caption }}</span>
              <div
                v-if="item.showAsSpecialField">
                <InfoIconWithTooltip
                  color="green"
                  :content="$t('AdditionalFields.ShowAsSpecialField')"
                  icon="eye"/>
              </div>
              <div
                v-if="item.binding">
                <InfoIconWithTooltip
                  color="#656262"
                  :content="item.info"
                  icon="link"/>
              </div>
            </div>
          </template>
        </v-treeview>
        <div v-else>
          {{ $t('Common.NoData') }}
        </div>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import InfoIconWithTooltip from 'components/common/elements/InfoIconWithTooltip.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { additionalFieldsMixin } from 'mixins'

export default {
  name: 'selectExistingField',
  mixins: [additionalFieldsMixin],
  data() {
    return {
      selected: [],
      groups: []
    }
  },
  props: {
    back_step: {
      type: Boolean
    },
    opened: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    treeItems: {
      type: Array,
      required: true
    },
    existItems: {
      type: Array,
      required: true
    },
    classifications: {
      type: Array,
    },
  },
  computed: {
    existinId() {
      return this.existItems.map(i => i.id)
    },
  },
  methods: {
    createGroup() {
      let groups = this.$_.groupBy(this.treeItems, 'typeId')
      const getInfo = (item) => {
        let result = `<b>${this.$t('AdditionalFields.FieldBinding')}</b>`
        if (item?.biddingTypeIds?.length) {
          result += `</br>${this.$t('AdditionalFields.TiedByBiddingType')}:<ul>`
          item.biddingTypeIds.forEach((biddingTypeId) => {
            result += `<li class="ml-4">${this.$store.getters.getBiddingTypes.find(i => i.biddingTypeId === biddingTypeId)?.titleRu ?? `${this.$t('Tenders.biddingTypes')} ${biddingTypeId}`}</li>`
          })
          result += '</ul>'
        }
        if (item?.classificationCodes?.length) {
          result += `</br>${this.$t('AdditionalFields.TiedByCategory')}:<ul>`
          item.classificationCodes.forEach((classificationCode) => {
            result += `<li class="ml-4">${this.classifications?.find(i => i.classificationCode === classificationCode)?.title ?? '-'}</li>`
          })
          result += '</ul>'
        }
        return result
      }
      this.groups = Object.entries(groups).map(([typeId, items]) => {
        items = items.filter(i => i.active)
          .map(i => {
            const binding = !!i.bindingCondition?.biddingTypeIds.length || !!i.bindingCondition?.classificationCodes?.length
            return {...i,
              locked: this.existinId.includes(i.id),
              binding: binding,
              info: binding ? getInfo(i.bindingCondition) : null,
              required: i.settingValues?.find(i => i.settingType === 'REQUIRED')?.value === 'true'
            }
          })
        return {
          type: this.additional_types.find(type => type.typeId == typeId) || {},
          children: items,
          id: typeId,
        }
      }
      ).filter(i => i.children?.length)
    },
    addFields() {
      const result = this.$_.cloneDeep(this.selected)
      if (this.$acl.check('isAdmin') ) {
        result.forEach((item) => {
          item.bindingCondition.biddingTypeIds = []
          item.bindingCondition.classificationCodes = []
        })
      }
      this.$emit('selectExistingFields', result)
    },
  },
  watch: {
    classifications: {
      immediate: true,
      deep: true,
      handler() {
        this.$store.dispatch('setBiddingTypes').then(() => {
          this.$nextTick(() => {
            this.createGroup()
          })
        })
      }
    }
  },
  components: {
    InfoIconWithTooltip,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss">
#fieldTree button.v-treeview-node__toggle + button.v-treeview-node__checkbox {
 display: none !important;
}
.select-existing-field {
  .v-treeview-node__toggle,
  .v-treeview-node__root:last-child .v-treeview-node__root:first-child,
  .v-treeview-node--leaf .v-treeview-node__level:first-child {
    display: none
  }
}
</style>
<style lang="scss" scoped>
.required-label::before {
  content: '*';
  font-size: 12px;
  color: var(--color-error);
}
.field-title {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
}
</style>
